import $ from 'jquery';

window.$ = $;
window.jQuery = $;


// vue
import { createApp } from 'vue'

// vue router
// import router from './router.js';

// PrimeVue
import PrimeVue from 'primevue/config';
import { definePreset } from '@primeuix/themes';
import Aura from '@primeuix/themes/aura';

// Primevue Config
import config from './primeConfig.js'

// Owncss
import './assets/scss/main.scss'

// App
import App from './App.vue'

// lang
import deDE from './lang/de.js'


const MyPreset = definePreset(Aura, config);


const app = createApp(App);
app.use(PrimeVue, {
    theme: {
        preset: MyPreset,
        options: {
            prefix: 'p',
            darkModeSelector: 'p-light',
            cssLayer: false,
            darkModeSelector: false || 'none',
        }
    },
    locale: deDE
});
// app.use(router);
app.mount('#app');
 